import { Flex } from '@lemonade-hq/uniclient-theme';
import { motion } from 'motion/react';
import type { PropsWithChildren } from 'react';
import { itemContentWrapperVariants } from '../../animations';

interface ItemContentWrapperProps extends PropsWithChildren {
  readonly isFirstRender?: boolean;
}

export const ItemContentWrapper: React.FC<ItemContentWrapperProps> = ({ children, isFirstRender }) => (
  <Flex
    animate="animate"
    as={motion.div}
    flexDirection="column"
    initial={isFirstRender ? undefined : 'initial'}
    variants={itemContentWrapperVariants}
    width="100%"
  >
    {children}
  </Flex>
);
